<template>
    <div class="video">
<!--      <div class="xl:block">-->
<!--        <div class="container mx-auto">-->
<!--          <div class="cta py-5 text-center xl:flex items-end">-->
<!--            <h2 class="text-blue pr-5">See how a physio can help you</h2>-->
<!--            <p class="text-blue pr-5">Use our new symptom checker for personalised advice</p>-->
<!--            <a href="https://checker.ascenti.co.uk" class="btn bg-blue text-white mx-auto xl:m-0">Start now</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
        <appointments-grid />

        <div v-if="appointments.length > 0 && filteredAppointments.length > 5" class="mt-4 text-center">
            <button class="btn btn-primary inline" @click.prevent="toggleShowAllClinics">
                <span v-if="showAllClinics">Fewer clinics</span>
                <span v-else>More clinics</span>
            </button>
        </div>

        <cookie-law theme="ascenti" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import CookieLaw from 'vue-cookie-law';
    import AppointmentsGrid from '../components/Appointments/AppointmentsGrid';

    export default {
        name: 'video-home',

        components: {
            AppointmentsGrid,
            CookieLaw
        },

        computed: {
            ...mapState('appointments', [
                'showAllClinics',
                'appointments',
            ]),

            filteredAppointments() {
                return this.$store.getters['appointments/filteredAppointments'];
            }
        },

        mounted() {
            const clinicID = process.env.VUE_APP_VIDEO_CLINIC_ID;
            const clinic = { ClinicID: clinicID };
            this.getNextAvailableAppointments({ clinic });

            this.$gtm.trackView('Video', '/video');
            this.showNavigation();
            this.setTheme('light');
            this.showComponent({ name: 'appointments-header', props: { ...this.headerProps() } });

            if (this.appointments.length) {
                this.showFooterAppointmentsMessage();
            } else {
                this.setFooterMessage(null);
            }

            this.listen('appointments.reload', [ this.reloadAppointments ]);

            this.listen('appointments.load', [
              this.showFooterAppointmentsMessage
            ]);

            this.$scrollTo('#app');
        },

        destroyed() {
            this.silence('appointments.load', [
                this.showFooterAppointmentsMessage
            ]);

            this.silence('appointments.reload', [ this.reloadAppointments ]);
        },

        methods: {
            ...mapActions('header', ['showComponent', 'showNavigation', 'setTheme']),
            ...mapActions('footer', ['setFooterMessage']),
            ...mapActions('appointments', ['toggleShowAllClinics', 'getAppointments', 'getNextAvailableAppointments']),

            reloadAppointments(e) {
                let params = {};

                if (e) {
                    params.startDate = e.date;
                }

                const callback = () => this.$nextTick(() => this.$scrollTo('#appointments'));

                this.getAppointments({ callback, params });
            },

            headerProps() {
                return {
                    pageTitle: 'Book an online physio appointment',
                    copy: 'Live one-to-one video consultations with one of our expert physios to fit around your work or lifestyle.',
                    priceType: 'virtual',
                    switchBlockLabel: "Visit a clinic",
                    switchBlockLink: "/",
                    switchBlockTitle: "Rather visit a clinic?",
                    switchBlockContent: "Book an appointment for a face-to-face consultation.",
                    items: [
                        {
                            icon: 'devices',
                            text: 'Use your computer or smart phone wherever you are'
                        },
                        {
                            icon: 'medical',
                            text: '30 minute consultation to create a personal treatment plan. <a target="_blank" href="https://www.ascenti.co.uk/article/online-physio-treatment" class="underline">Read more</a>'
                        },
                        {
                            icon: 'security',
                            text: 'CQC registered - NHS partner - secure data. <a target="_blank" href="https://www.ascenti.co.uk/values/quality-and-safety" class="underline">Read more</a>'
                        }
                    ]
                }
            },
        },
    }
</script>
